import React from 'react';
import '../css/LegalPages.css';

const MesafeliSatisSozlesmesi = () => {
  return (
    <div className="legal-container">
      <h1>Mesafeli Satış Sözleşmesi</h1>

      <section>
        <h3>1. Taraflar</h3>
        <p>
          İşbu sözleşme, halisahacim.com sitesi ile siteye üye olan kullanıcı veya işletme (bundan sonra “Alıcı” olarak anılacaktır) arasında yapılmıştır.
        </p>
      </section>

      <section>
        <h3>2. Konu</h3>
        <p>
          Bu sözleşmenin konusu, Alıcı’nın elektronik ortamda yaptığı ödeme karşılığında işletme hesabının aktif edilmesi ve platform üzerindeki tanıtım, rezervasyon alma gibi hizmetlerden faydalanmasına ilişkindir.
        </p>
      </section>

      <section>
        <h3>3. Sözleşmenin Süresi</h3>
        <p>
          Hizmetin başlangıcı ödeme tarihidir ve hizmet süresi bir aydır. Alıcı tarafından yenileme yapılmadığı takdirde hizmet sona erer.
        </p>
      </section>

      <section>
        <h3>4. Ödeme</h3>
        <p>
          Ödeme kredi kartı ile İyzico altyapısı üzerinden yapılır. İşlem tamamlandığında işletme hesabı aktif edilir.
        </p>
      </section>

      <section>
        <h3>5. Cayma Hakkı</h3>
        <p>
          Dijital hizmetler kapsamında olduğundan, hizmetin sunulmasına başlandıktan sonra cayma hakkı bulunmamaktadır.
        </p>
      </section>

      <section>
        <h3>6. Yetkili Mahkeme</h3>
        <p>
          İşbu sözleşmeden doğabilecek uyuşmazlıklarda Antalya Mahkemeleri ve İcra Daireleri yetkilidir.
        </p>
      </section>

      <section>
        <h3>7. İletişim</h3>
        <p>
          Tüm şikayet, öneri ve talepler için <a href="mailto:halisahacim.com@gmail.com">halisahacim.com@gmail.com</a> adresi üzerinden iletişim kurulabilir.
        </p>
      </section>
    </div>
  );
};

export default MesafeliSatisSozlesmesi;
